export const reportsTeamErgo = {
    namespaced: true,

    state: {
        filter: {
            distances: [],
            times: [],
            hrIntensities: [],
            byErgoId: [],
            tags: [],
            athletes: [],
            focuses: [],
            structure: null
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        },

        allStructures(state) {
            return state.allStructures;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                distances: [],
                times: [],
                hrIntensities: [],
                byErgoId: [],
                tags: [],
                athletes: [],
                focuses: [],
                structure: null
            };
        },

        setAthletes(state, payload) {
            state.filter.athletes = payload;
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setDistance(state, payload) {
            state.filter.distances = payload;
        },

        setTime(state, payload) {
            state.filter.times = payload;
        },

        setErgoType(state, payload) {
            state.filter.byErgoId = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        },

        setStructure(state, payload) {
            state.filter.structure = payload;
        }
    }
};

export default reportsTeamErgo;
